import React, { useEffect, useState } from "react";
import { ROUTES } from "../utils/Routes";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { useTabs } from "../hooks/useTabs";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import Select from "../ui/Select";
import SelectBox from "../ui/SelectBox";
import { drawPicker } from "../popovers/Picker";
import EnumField from "../ui/EnumField";
import Divider from "../ui/Divider";
import Button from "../ui/Button";
import Float from "../ui/Float";
import { kbdEvent } from "../utils/Utils";
import Spin from "../ui/Spin";

export default function PrinterSettings(props) {
    const {
        controller = "",
        route = ROUTES.GLOBAL.PRINTER_SETTINGS,
        callback = () => { }
    } = props;

    const [settings, setSettings] = useState();
    const [loading, setLoading] = useState(false)

    const makePrinter = (printer = {}) => ({
        printer_name: printer?.printer_name || "",
        stub_uri_name: printer?.stub_uri_name || "",
        stub_friendly_name: printer?.stub_friendly_name || ""
    });



    const { tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs } = useTabs([], "printer_main_type");

    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === "function") {
            el.blur();
        }
    };

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === "function") {
            el.focus();
        }
    };



    const selectPrinter = (_value, callback = () => { }) => {

        blurField();
        pubCall("stub.getAllPrinters", {}, (_s, _r) => {
            if (_s) {
                drawPicker({
                    controller: controller,
                    value: _value, title: "Installed Printers", closeable: true, height: 300, ref: null, route: route, close: () => { focusField() }, callback: (e) => {
                        if (e) {
                            callback(e)
                        }
                        focusField();
                    }, offset: [0, 10],
                    options: _r.map(item => {
                        return ({
                            value: { name: item?.printer_name, stub: item?.stub_uri_name } || "",
                            label: item.stub_friendly_name + ": " + item?.printer_name + " "|| ""
                        })
                    })
                })
            } else {
                showError(_r);
                focusField();
            }
        })

    }


    const hydrateTabs = (_settings = {}) => {
        setTabs([

            // MAIN
            { key: "printer_main_type", value: _settings?.printer_main_type ?? "", skip: false },
            { key: "printer_main_printer_name", value: _settings?.printer_main_printer?.printer_name ?? "", skip: false },
            { key: "printer_main_stub_uri_name", value: _settings?.printer_main_printer?.stub_uri_name ?? "", skip: true },
            { key: "printer_main_stub_friendly_name", value: _settings?.printer_main_printer?.stub_friendly_name ?? "", skip: true },

            // CHEQUE
            { key: "printer_cheque_type", value: _settings?.printer_cheque_type ?? "", skip: false },
            { key: "printer_cheque_printer_name", value: _settings?.printer_cheque_printer?.printer_name ?? "", skip: false },
            { key: "printer_cheque_stub_uri_name", value: _settings?.printer_cheque_printer?.stub_uri_name ?? "", skip: true },
            { key: "printer_cheque_stub_friendly_name", value: _settings?.printer_cheque_printer?.stub_friendly_name ?? "", skip: true },
            { key: "printer_cheque_format", value: _settings?.printer_cheque_format, skip: false },

            // RECEIPT
            { key: "printer_receipt_type", value: _settings?.printer_receipt_type ?? "", skip: false },
            { key: "printer_receipt_printer_name", value: _settings?.printer_receipt_printer?.printer_name ?? "", skip: false },
            { key: "printer_receipt_stub_uri_name", value: _settings?.printer_receipt_printer?.stub_uri_name ?? "", skip: true },
            { key: "printer_receipt_stub_friendly_name", value: _settings?.printer_receipt_printer?.stub_friendly_name ?? "", skip: true },
            { key: "printer_receipt_model", value: _settings?.printer_receipt_model ?? "", skip: false },
            { key: "printer_receipt_width", value: _settings?.printer_receipt_width ?? "", skip: false },
            { key: "printer_receipt_copies", value: _settings?.printer_receipt_copies ?? "", skip: false },
            { key: "printer_receipt_open_drawer", value: _settings?.printer_receipt_open_drawer ?? "", skip: false },
            { key: "printer_receipt_show_isbns", value: _settings?.printer_receipt_show_isbns ?? "", skip: false },

            // Invoice
            { key: "printer_invoice_type", value: _settings?.printer_invoice_type ?? "", skip: false },
            { key: "printer_invoice_printer_name", value: _settings?.printer_invoice_printer?.printer_name ?? "", skip: false },
            { key: "printer_invoice_stub_uri_name", value: _settings?.printer_invoice_printer?.stub_uri_name ?? "", skip: true },
            { key: "printer_invoice_stub_friendly_name", value: _settings?.printer_invoice_printer?.stub_friendly_name ?? "", skip: true },
            { key: "printer_invoice_copies", value: _settings?.printer_invoice_copies ?? 1, skip: false },

            // Book Label
            { key: "printer_book_label_type", value: _settings?.printer_book_label_type ?? "", skip: false },
            { key: "printer_book_label_printer_name", value: _settings?.printer_book_label_printer?.printer_name ?? "", skip: false },
            { key: "printer_book_label_stub_uri_name", value: _settings?.printer_book_label_printer?.stub_uri_name ?? "", skip: true },
            { key: "printer_book_label_stub_friendly_name", value: _settings?.printer_book_label_printer?.stub_friendly_name ?? "", skip: true },
            { key: "printer_book_label_style", value: _settings?.printer_book_label_style ?? "", skip: false },
            { key: "printer_book_label_company", value: _settings?.printer_book_label_company ?? "", skip: false },
            { key: "printer_book_label_barcode", value: !!_settings?.printer_book_label_barcode, skip: false },
            { key: "printer_book_label_profit_margin", value: !!_settings?.printer_book_label_profit_margin, skip: false },

            { key: "printer_book_label_receive_date", value: _settings?.printer_book_label_receive_date ?? "", skip: false },
            { key: "printer_book_label_thermal_sale_option", value: _settings?.printer_book_label_thermal_sale_option ?? "", skip: false },
            { key: "printer_book_label_print_author", value: !!_settings?.printer_book_label_print_author, skip: false },
            { key: "printer_book_label_price_white_on_black", value: !!_settings?.printer_book_label_price_white_on_black, skip: false },

            // SHIP
            { key: "printer_ship_type", value: _settings?.printer_ship_type ?? "", skip: false },
            { key: "printer_ship_printer_name", value: _settings?.printer_ship_printer?.printer_name ?? "", skip: false },
            { key: "printer_ship_stub_uri_name", value: _settings?.printer_ship_printer?.stub_uri_name ?? "", skip: true },
            { key: "printer_ship_stub_friendly_name", value: _settings?.printer_ship_printer?.stub_friendly_name ?? "", skip: true },
            { key: "printer_ship_style", value: _settings?.printer_ship_style ?? "", skip: false },



        ]);
    };

    const getPrinterSettings = () => {
        setLoading(true);
        pubCall("work_station_setting.get", {}, (_s, _r) => {
            if (_s) {
                setSettings(_r);
                hydrateTabs(_r);
            } else {
                showError(_r);
            }
            setLoading(false);
        });
    };

    useEffect(getPrinterSettings, []);

    const save = () => {

        setLoading(true);
        blurField();

        const params = {
            printer_main_type: getVal("printer_main_type"),
            printer_main_printer: makePrinter({
                printer_name: getVal("printer_main_printer_name"),
                stub_uri_name: getVal("printer_main_stub_uri_name")
            }),

            printer_cheque_type: getVal("printer_cheque_type"),
            printer_cheque_format: getVal("printer_cheque_format"),
            printer_cheque_printer: makePrinter({
                printer_name: getVal("printer_cheque_printer_name"),
                stub_uri_name: getVal("printer_cheque_stub_uri_name")
            }),

            printer_invoice_type: getVal("printer_invoice_type"),
            printer_invoice_copies: Number(getVal("printer_invoice_copies") || 1),
            printer_invoice_printer: makePrinter({
                printer_name: getVal("printer_invoice_printer_name"),
                stub_uri_name: getVal("printer_invoice_stub_uri_name")
            }),

            printer_receipt_type: getVal("printer_receipt_type"),
            printer_receipt_copies: Number(getVal("printer_receipt_copies") || 1),
            printer_receipt_model: getVal("printer_receipt_model"),
            printer_receipt_width: Number(getVal("printer_receipt_width") || 40),
            printer_receipt_open_drawer: getVal("printer_receipt_open_drawer"),
            printer_receipt_show_isbns: !!getVal("printer_receipt_show_isbns"),
            printer_receipt_printer: makePrinter({
                printer_name: getVal("printer_receipt_printer_name"),
                stub_uri_name: getVal("printer_receipt_stub_uri_name")
            }),


            printer_book_label_type: getVal("printer_book_label_type"),
            printer_book_label_style: getVal("printer_book_label_style"),
            printer_book_label_company: getVal("printer_book_label_company"),
            printer_book_label_receive_date: getVal("printer_book_label_receive_date"),
            printer_book_label_thermal_sale_option: getVal("printer_book_label_thermal_sale_option"),
            printer_book_label_barcode: !!getVal("printer_book_label_barcode"),
            printer_book_label_price_white_on_black: !!getVal("printer_book_label_price_white_on_black"),
            printer_book_label_print_author: !!getVal("printer_book_label_print_author"),
            printer_book_label_printer: makePrinter({
                printer_name: getVal("printer_book_label_printer_name"),
                stub_uri_name: getVal("printer_book_label_stub_uri_name")
            }),

            printer_ship_type: getVal("printer_ship_type"),
            printer_ship_style: getVal("printer_ship_style"),
            printer_ship_printer: makePrinter({
                printer_name: getVal("printer_ship_printer_name"),
                stub_uri_name: getVal("printer_ship_stub_uri_name")
            }),
            printer_book_label_profit_margin : getVal("printer_book_label_profit_margin")

        };



        pubCall("work_station_setting.edit", { new_info: params }, (_s, _r) => {
            if (_s) {
                callback(false);
                showMessage("Settings saved")
            } else {
                showError(_r);
            }
            setLoading(false)
        });
    };

    const actions = [
        { key: KBD.ESCAPE, action: () => callback(false) },
        { key: KBD.PAGE_DOWN, action: () => save() },
        { key: KBD.ARROW_DOWN, action: () => next() },
        { key: KBD.ARROW_UP, action: () => prev() },
        { key: KBD.TAB, action: () => next() },
        { key: KBD.SHIFT_TAB, action: () => prev() },
    ];

    useEffect(() => {
        if (refs?.current[index]) refs.current[index].focus();

        const cleanup = listen(
            controller,
            route,
            actions,
            false,
            [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN, KBD.TAB, KBD.SHIFT_TAB]
        );

        return cleanup;
    }, [tabs, index]);

    const statuses = {
        // Main
        printer_main_type: "<W>indows, <P>assthru (Windows), <F>ile",
        printer_main_printer_name: "<PgUp> to select Windows printer, or use LPT1, or print to {file.txt}",

        // Cheque
        printer_cheque_type: "<W>indows, <P>assthru (Windows), <F>ile",
        printer_cheque_printer_name: "<PgUp> to select Windows printer, or use LPT1, or print to {file.txt}",
        printer_cheque_format: "1 = 2part-ncr, 2 = laser, 3 = bank compliant, 4 = bank comp. with MM DD YYYY, 0 = none",

        // Receipt
        printer_receipt_type: "<W>indows, <P>assthru (Windows), <F>ile",
        printer_receipt_printer_name: "<PgUp> to select Windows printer, or use LPT1, or print to {file.txt}",
        printer_receipt_model: "<S>tar, <E>pson/Samsung, <I>thaca, <T>hermal, <N>on-receipt printer",
        printer_receipt_width: "Maximum characters per line. 40 (default) or 48",
        printer_receipt_copies: "Normally only one copy of a receipt is required",
        printer_receipt_open_drawer: "<Y>es, <N>o, <C>ash only",
        printer_receipt_show_isbns: "<Y>es, <N>o. Hide ISBNs for a cleaner receipt",

        // Invoice
        printer_invoice_type: "<W>indows, <P>assthru (Windows), <F>ile",
        printer_invoice_printer_name: "<PgUp> to select Windows printer, or use LPT1, or print to {file.txt}",
        printer_invoice_copies: "Number of invoice copies",

        // Shipping
        printer_ship_type: "<W>indows, <P>assthru (Windows), <F>ile",
        printer_ship_printer_name: "<PgUp> to select Windows printer, or use LPT1, or print to {file.txt}",
        printer_ship_style: "[P]aper, Zebra, [C]ognitive, [F]ilt-tabdelim, Pinfeed : [G]eneric [C]ustom",

        // Book Label
        printer_book_label_type: "<W>indows, <P>assthru (Windows), <F>ile",
        printer_book_label_printer_name: "<PgUp> to select Windows printer, or use LPT1, or print to {file.txt}",
        printer_book_label_style: "0 - None, Z2 - Zebra 200 DPI, Z3 - Zebra 300 DPI, T - Cognitive",
        printer_book_label_company: "Optional: Your company name abbreviated 16 to char)",
        printer_book_label_receive_date: "[C]ode (eg. D3 for April 2023) or [D]ate (eg. Apr23) to obscure/show RcvdDte ",
        printer_book_label_thermal_sale_option: "C=Class file discount, D=//% discount, S=//$ sale price",
        printer_book_label_barcode: "Yes/No to include the bar code",
        printer_book_label_profit_margin: "Yes/No to include the Profit Margin code",
        printer_book_label_price_white_on_black: "The large 'sale' price is prominent on the white label stock",
        printer_book_label_print_author: "Prints Author instead of Supplier, Discound-code and Qty",
    };


    const printer_names = [
        { value: "W", label: "Windows", key: KBD.W },
        { value: "P", label: "Passthru", key: KBD.P },
        { value: "F", label: "File", key: KBD.F },
    ]

    const check_format = [
        { value: "1", label: "1", key: KBD.Digit1 },
        { value: "2", label: "2", key: KBD.Digit2 },
        { value: "3", label: "3", key: KBD.Digit3 },
        { value: "4", label: "4", key: KBD.Digit4 },
        { value: "0", label: "0", key: KBD.Digit0 },
    ]

    const models = [
        { value: "S", label: "S", key: KBD.S },
        { value: "E", label: "E", key: KBD.E },
        { value: "I", label: "I", key: KBD.I },
        { value: "T", label: "T", key: KBD.T },
        { value: "N", label: "N", key: KBD.N },
    ]

    const yes_no = [
        { value: true, label: "Y", key: KBD.Y },
        { value: false, label: "N", key: KBD.N },
    ];

    const date_formats = [
        { value: "C", label: "C", key: KBD.C },
        { value: "D", label: "D", key: KBD.D },
    ];

    const cash_drawer = [
        { value: "Y", label: "Y", key: KBD.Y },
        { value: "N", label: "N", key: KBD.N },
        { value: "C", label: "C", key: KBD.C },
    ];





    const receipt_widths = [
        { value: 40, label: "40", key: KBD.Digit4 },
        { value: 48, label: "48", key: KBD.Digit8 },
    ];

    const shipping_styles = [
        { value: "P", label: "P", key: KBD.P },
        { value: "Z", label: "Z", key: KBD.Z },
        { value: "T", label: "T", key: KBD.T },
        { value: "F", label: "F", key: KBD.F },
        { value: "G", label: "G", key: KBD.G },
        { value: "C", label: "C", key: KBD.C },
    ];

    return (
        <>
            <Spin loading={loading}>
                <div style={{ width: "800px" }}>
                    <div className="shim" />
                    <div className="shim" />

                    {/* MAIN */}
                    <Space style={{ alignItems: "flex-start" }}>
                        <Label width={100}>Main</Label>

                        <div>
                            <Space style={{ alignItems: "flex-start" }}>
                                <Label width={90}>Printer is a</Label>

                                <EnumField
                                    width={130}
                                    allow_empty={false}
                                    {...editProps("printer_main_type")}
                                    onChange={(e) => {
                                        update("printer_main_type", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={printer_names}
                                />

                                <Label>type connected to</Label>

                                <Input
                                    {...editProps("printer_main_printer_name")}
                                    onEnter={() => next()}
                                    onPageUp={() =>
                                        selectPrinter(getVal("printer_main_printer_name"), (_result) => {

                                            update({
                                                printer_main_printer_name: _result.name,
                                                printer_main_stub_uri_name: _result.stub,
                                            });
                                        })
                                    }
                                    edit
                                    width={300}
                                />
                            </Space>
                        </div>
                    </Space>

                    <Divider style={{ "padding": "10px 0px" }} />

                    {/* CHEQUE */}
                    <Space style={{ alignItems: "flex-start" }}>
                        <Label width={100}>Cheque</Label>

                        <div>
                            <Space style={{ alignItems: "flex-start" }}>
                                <Label width={90}>Printer is a</Label>

                                <EnumField
                                    width={130}
                                    allow_empty={false}
                                    {...editProps("printer_cheque_type")}
                                    onChange={(e) => {
                                        update("printer_cheque_type", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={printer_names}
                                />

                                <Label>type connected to</Label>

                                <Input
                                    {...editProps("printer_cheque_printer_name")}
                                    onEnter={() => next()}
                                    onPageUp={() =>
                                        selectPrinter(getVal("printer_cheque_printer_name"), (_result) => {
                                            update({
                                                printer_cheque_printer_name: _result.name,
                                                printer_cheque_stub_uri_name: _result.stub,
                                            });
                                        })
                                    }
                                    edit
                                    width={300}
                                />
                            </Space>
                        </div>
                    </Space>

                    <div className="shim" />

                    <Space style={{ alignItems: "flex-start" }}>
                        <Label width={100}></Label>

                        <div>
                            <Space style={{ alignItems: "flex-start" }}>
                                <Label width={90}>Check format</Label>

                                <EnumField
                                    width={20}
                                    allow_empty={false}
                                    {...editProps("printer_cheque_format")}
                                    onChange={(e) => {
                                        update("printer_cheque_format", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={check_format}
                                />
                            </Space>
                        </div>
                    </Space>

                    <Divider style={{ "padding": "10px 0px" }} />

                    {/* RECEIPT */}
                    <Space style={{ alignItems: "flex-start" }}>
                        <Label width={100}>Receipt</Label>

                        <div>
                            <Space style={{ alignItems: "flex-start" }}>
                                <Label width={90}>Printer is a</Label>

                                <EnumField
                                    width={130}
                                    allow_empty={false}
                                    {...editProps("printer_receipt_type")}
                                    onChange={(e) => {
                                        update("printer_receipt_type", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={printer_names}
                                />

                                <Label>type connected to</Label>

                                <Input
                                    {...editProps("printer_receipt_printer_name")}
                                    onEnter={() => next()}
                                    onPageUp={() =>
                                        selectPrinter(getVal("printer_receipt_printer_name"), (_result) => {
                                            update({
                                                printer_receipt_printer_name: _result.name,
                                                printer_receipt_stub_uri_name: _result.stub,
                                            });
                                        })
                                    }
                                    edit
                                    width={300}
                                />
                            </Space>

                            <div className="shim" />

                            <Space style={{ alignItems: "flex-start" }}>
                                <Label width={90}>Model</Label>

                                <EnumField
                                    width={20}
                                    allow_empty={false}
                                    {...editProps("printer_receipt_model")}
                                    onChange={(e) => {
                                        update("printer_receipt_model", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={models}
                                />

                                <Label>Width</Label>

                                <EnumField
                                    width={35}
                                    allow_empty={false}
                                    {...editProps("printer_receipt_width")}
                                    onChange={(e) => {
                                        update("printer_receipt_width", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={receipt_widths}
                                />

                                <Label>Copies</Label>

                                <Input
                                    chars={["1", "2", "3", "4", "5", "6", "7", "8", "9"]}
                                    maxLength={1}
                                    {...editProps("printer_receipt_copies")}
                                    onBlur={(e) => {
                                        if (!e) {
                                            setTimeout(() => {
                                                update("printer_receipt_copies", "1");
                                            }, 10);
                                        }
                                    }}
                                    onFill={() => next()}
                                    onEnter={() => next()}
                                    width={20}
                                />

                                <Label>Open Drawer</Label>

                                <EnumField
                                    width={20}
                                    allow_empty={false}
                                    {...editProps("printer_receipt_open_drawer")}
                                    onChange={(e) => {
                                        update("printer_receipt_open_drawer", e);
                                        if (e) next();
                                    }}
                                    options={cash_drawer}
                                    onEnter={() => next()}
                                />

                                <Label>Show ISBNs?</Label>

                                <EnumField
                                    width={20}
                                    allow_empty={false}
                                    {...editProps("printer_receipt_show_isbns")}
                                    onChange={(e) => {
                                        update("printer_receipt_show_isbns", e);
                                        next();
                                    }}
                                    options={yes_no}
                                    onEnter={() => next()}
                                />
                            </Space>
                        </div>
                    </Space>

                    <Divider style={{ "padding": "10px 0px" }} />

                    {/* INVOICE */}
                    <Space style={{ alignItems: "flex-start" }}>
                        <Label width={100}>Invoice</Label>

                        <div>
                            <Space style={{ alignItems: "flex-start" }}>
                                <Label width={90}>Printer is a</Label>

                                <EnumField
                                    width={130}
                                    allow_empty={false}
                                    {...editProps("printer_invoice_type")}
                                    onChange={(e) => {
                                        update("printer_invoice_type", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={printer_names}
                                />

                                <Label>type connected to</Label>

                                <Input
                                    {...editProps("printer_invoice_printer_name")}
                                    onEnter={() => next()}
                                    onPageUp={() =>
                                        selectPrinter(getVal("printer_invoice_printer_name"), (_result) => {
                                            update({
                                                printer_invoice_printer_name: _result.name,
                                                printer_invoice_stub_uri_name: _result.stub,
                                            });
                                        })
                                    }
                                    edit
                                    width={300}
                                />
                            </Space>

                            <div className="shim" />

                            <Space>
                                <Label width={90}>Copies</Label>

                                <Input
                                    chars={["1", "2", "3", "4", "5", "6", "7", "8", "9"]}
                                    maxLength={1}
                                    {...editProps("printer_invoice_copies")}
                                    onBlur={(e) => {
                                        if (!e) {
                                            setTimeout(() => {
                                                update("printer_invoice_copies", "1");
                                            }, 10);
                                        }
                                    }}
                                    onFill={() => next()}
                                    onEnter={() => next()}
                                    width={20}
                                />
                            </Space>
                        </div>
                    </Space>

                    <Divider style={{ "padding": "10px 0px" }} />

                    {/* BOOK LABEL */}
                    <Space style={{ alignItems: "flex-start" }}>
                        <Label width={100}>Book Label</Label>

                        <div>
                            <Space style={{ alignItems: "flex-start" }}>
                                <Label width={90}>Printer is a</Label>

                                <EnumField
                                    width={130}
                                    allow_empty={false}
                                    {...editProps("printer_book_label_type")}
                                    onChange={(e) => {
                                        update("printer_book_label_type", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={printer_names}
                                />

                                <Label>type connected to</Label>

                                <Input
                                    {...editProps("printer_book_label_printer_name")}
                                    onEnter={() => next()}
                                    onPageUp={() =>
                                        selectPrinter(getVal("printer_book_label_printer_name"), (_result) => {
                                            update({
                                                printer_book_label_printer_name: _result.name,
                                                printer_book_label_stub_uri_name: _result.stub,
                                            });
                                        })
                                    }
                                    edit
                                    width={300}
                                />
                            </Space>

                            <div className="shim" />

                            <Space>
                                <Label width={90}>Style</Label>

                                <Input

                                    width={30}
                                    maxLength={2}
                                    uppercase
                                    chars={["0", "2", "3", "Z", "T"]}
                                    {...editProps("printer_book_label_style")}
                                    onChange={(e) => {
                                        if (e === "T" || e === "0" || e === "3") {
                                            update("printer_book_label_style", e)
                                            next();
                                        } else {
                                            update("printer_book_label_style", e)
                                        }

                                    }}
                                    onFill={(e) => {
                                        if (e?.length === 2) {
                                            if (e !== "Z2" && e !== "Z3") {
                                                next();
                                                setTimeout(() => {
                                                    update("printer_book_label_style", "0")
                                                }, 10)

                                            } else {
                                                next();
                                            }
                                        }
                                    }}


                                />



                                <Label>Name</Label>

                                <Input
                                    {...editProps("printer_book_label_company")}
                                    onEnter={() => next()}
                                    edit
                                    width={140}
                                />

                                <Label>Barcode?</Label>

                                <EnumField
                                    width={20}
                                    allow_empty={false}
                                    {...editProps("printer_book_label_barcode")}
                                    onChange={(e) => {
                                        update("printer_book_label_barcode", e);
                                        if (e) next();
                                    }}
                                    options={yes_no}
                                />

                                <Label>PC?</Label>

                                <EnumField
                                    width={20}
                                    allow_empty={false}
                                    {...editProps("printer_book_label_profit_margin")}
                                    onChange={(e) => {
                                        update("printer_book_label_profit_margin", e);
                                        if (e) next();
                                    }}


                                    options={yes_no}
                                />

                            </Space>

                            <div className="shim" />

                            <Space>
                                <Label width={90}>Date format</Label>

                                <EnumField

                                    options={date_formats}
                                    {...editProps("printer_book_label_receive_date")}
                                    onEnter={() => next()}
                                    edit
                                    width={20}
                                />

                                <Label>Thermal options: Do sale label for:</Label>

                                <Input
                                    {...editProps("printer_book_label_thermal_sale_option")}
                                    onEnter={() => next()}
                                    edit
                                    width={120}
                                />
                            </Space>

                            <div className="shim" />

                            <Space>
                                <Label width={192}>Sale label: Include author?</Label>
                                <EnumField
                                    width={20}
                                    allow_empty={false}
                                    {...editProps("printer_book_label_print_author")}
                                    onChange={(e) => {
                                        update("printer_book_label_print_author", e);
                                        if (e) next();
                                    }}
                                    options={yes_no}
                                />
                                <Label>Price is White on Black?</Label>
                                <EnumField
                                    allow_empty={false}
                                    width={20}
                                    {...editProps("printer_book_label_price_white_on_black")}
                                    onChange={(e) => {
                                        update("printer_book_label_price_white_on_black", e);
                                        if (e) next();
                                    }}

                                    options={[
                                        { value: true, label: "Y", key: KBD.Y },
                                        { value: false, label: "N", key: KBD.N },
                                    ]}
                                />
                            </Space>



                        </div>
                    </Space>

                    <Divider style={{ "padding": "10px 0px" }} />

                    

                    {/* SHIPPING */}
                    <Space style={{ alignItems: "flex-start" }}>
                        <Label width={100}>Shipping</Label>

                        <div>
                            <Space style={{ alignItems: "flex-start" }}>
                                <Label width={90}>Printer is a</Label>

                                <EnumField
                                    width={130}
                                    allow_empty={false}
                                    {...editProps("printer_ship_type")}
                                    onChange={(e) => {
                                        update("printer_ship_type", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={printer_names}
                                />

                                <Label>type connected to</Label>

                                <Input
                                    {...editProps("printer_ship_printer_name")}
                                    onEnter={() => next()}
                                    onPageUp={() =>
                                        selectPrinter(getVal("printer_ship_printer_name"), (_result) => {
                                            update({
                                                printer_ship_printer_name: _result.name,
                                                printer_ship_stub_uri_name: _result.stub,
                                            });
                                        })
                                    }
                                    edit
                                    width={300}
                                />
                            </Space>

                            <div className="shim" />

                            <Space>
                                <Label width={90}>Style</Label>

                                <EnumField
                                    width={20}
                                    {...editProps("printer_ship_style")}
                                    onChange={(e) => {
                                        update("printer_ship_style", e);
                                        if (e) next();
                                    }}
                                    onEnter={() => next()}
                                    options={shipping_styles}
                                    allow_freeform
                                />
                            </Space>



                        </div>
                    </Space>

                    <Float>
                        <div>&nbsp;</div>
                        <Button onClick={() => kbdEvent(KBD.PAGE_DOWN)}>Save Changes</Button>
                    </Float>

                    <div className="shim" />
                    <div className="shim" />
                    <div className="shim" />
                    <div className="shim" />
                    <Status type="active">
                        <InfoIcon />
                        {statuses?.[index]}
                    </Status>
                </div>
            </Spin>
        </>
    );
}